import { themeColors } from '@/theme/colors';
import { Flex } from '@lego/klik-ui';

type SummaryRowProps = {
  label: string;
  value: string;
  subValue?: string;
  size?: 'small' | 'medium';
};

const SummaryRow = ({
  label,
  value,
  subValue,
  size = 'medium',
}: SummaryRowProps) => {
  const isSmall = size === 'small';
  return (
    <Flex flexDir="column" gap="2px">
      <span
        className={isSmall ? 'label-xs-medium' : 'label-md-medium'}
        style={{ color: themeColors.content.default }}
      >
        {label}
      </span>
      <span
        className={isSmall ? 'label-xs-regular' : 'label-md-regular'}
        style={{ color: themeColors.content.default }}
      >
        {value}
      </span>
      {subValue && !isSmall && (
        <span
          className="label-sm-regular"
          style={{ color: themeColors.content.subtle }}
        >
          {subValue}
        </span>
      )}
    </Flex>
  );
};

export default SummaryRow;
